module.exports = __webpack_public_path__ + "static/media/ad-tray-price.172ea1ba.svg";